import EventEmitter from "./EventEmitter.js"

/**
 * CLASS: Time
 * 
 * - generates tick event at 60fps
 */
export default class Time extends EventEmitter {
    constructor()
    {
        // Base Class Setup
        super()

        // Setup
        this.start = Date.now()     // time experience started (ms)
        this.previous = this.start
        this.elapsed = 0
        this.delta = 16             // 16ms/frame = 60fps
        this.visible = true

        // Tick Function
        window.requestAnimationFrame(() => this.tick())
        window.addEventListener('visibilitychange', () => this.onVisibility())
    }

    tick()
    {
        // Update Setup
        const currentTime = Date.now()
        this.delta = currentTime - this.previous
        this.previous = currentTime
        this.elapsed = this.previous - this.start

        // Trigger Tick Event
        if(this.visible)
        {
            this.trigger('tick')
        }

        window.requestAnimationFrame(() => this.tick())
    }

    onVisibility()
    {
        if(document.visibilityState === 'visible')
        {
            this.visible = true
            this.trigger('visible')
        }
        else {
            this.visible = false
        }
    }
}